<div class="h-full mt-24px pb-[100px] px-12px custom-filter">
	<div class="flex justify-between items-center">
		<h1 class="tw-font-bold mb-0 font-semibold text-[24px]">
			{{ 'GENERAL_LABELS.FILTRATION' | translate }}
		</h1>
		<button *ngIf="filterCount" (click)="resetFilter()" class="flex text-link">
			{{ 'ACTIONS.RESET' | translate }}
			<img
				class="align-middle mx-2"
				src="assets/images/icon-reset.svg"
				alt="icon"
			/>
		</button>
	</div>
	<div class="mt-24px">
		<p class="text-[18px] ltr:font-DIN-Bold font-bold rtl:font-medium">
			{{ 'GENERAL_LABELS.DATE_RANGES' | translate }}
		</p>
		<app-custom-datepicker
			[defaultValue]="getController('startDate')?.value"
			label="GENERAL_LABELS.START_DATE"
			(dateValue)="getController('startDate')?.setValue($event)"
		></app-custom-datepicker>
		<app-custom-datepicker
			[defaultValue]="getController('endDate')?.value"
			label="GENERAL_LABELS.END_DATE"
			(dateValue)="getController('endDate')?.setValue($event)"
		></app-custom-datepicker>
		<mat-error>
			<div
				class="whitespace-nowrap"
				*ngIf="
					getController('endDate')?.value < getController('startDate')?.value &&
					getController('endDate')?.value
				"
			>
				{{ 'VALIDATION.END_DATE_ERROR' | translate }}
			</div>
		</mat-error>

		<div class="w-100 h-[1px] bg-secondry-color-Gray my-24px"></div>
		<h1 class="text-font-18 font-DIN-bold mb-12px">
			{{ 'WALLET.WALLET_FILTER.TRANSACTION_TYPE' | translate }}
		</h1>
		<div *ngFor="let enum of spTransactionEnum">
			<mat-checkbox
				[checked]="
					filterForm?.controls?.transactionType?.value?.includes(enum?.value)
				"
				[value]="enum?.value"
				class="ltr:mr-2 rtl:ml-2 mb-[19px]"
				(change)="transactionChanged($event, 'transactionType')"
			></mat-checkbox>
			{{ 'WALLET.WALLET_FILTER.' + enum?.name.toUpperCase() | translate }}
		</div>

		<button
			(click)="submit()"
			[disabled]="
				filterCount == 0 ||
				(getController('endDate').value < getController('startDate').value &&
					getController('endDate').value)
			"
			class="bg-gradient text-white w-[89%] p-0 absolute bottom-5"
			mat-button
		>
			{{ 'ACTIONS.APPLY_FILTER' | translate }}
		</button>
	</div>
</div>
